import { render, staticRenderFns } from "./SecureIcons.vue?vue&type=template&id=1f83be87&scoped=true&"
import script from "./SecureIcons.vue?vue&type=script&lang=js&"
export * from "./SecureIcons.vue?vue&type=script&lang=js&"
import style0 from "./SecureIcons.vue?vue&type=style&index=0&id=1f83be87&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f83be87",
  null
  
)

export default component.exports